/* eslint-disable */
import { JsonRpcProvider, Web3Provider } from '@ethersproject/providers'
import { rpc_urls } from 'config/constants/exchange'
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { bsc, bscTestnet, Chain } from 'wagmi/chains'

export const provider = (chainId) => {
  return new JsonRpcProvider(rpc_urls[chainId]);
}


export const web3provider = (chainId) => {
  return new Web3Provider(rpc_urls[chainId]);
}

export const baseSepolia: Chain = {
  id: 84532,
  name: "Base Sepolia",
  network: "base-sepolia",
  nativeCurrency: {
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.base.org"],
    },
    public: {
      http: ["https://sepolia.base.org"],
    },
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://sepolia.basescan.org",
    },
    etherscan: {
      name: "Basescan",
      url: "https://sepolia.basescan.org",
    },
  },
  contracts: {
    multicall3: {
      address: "0x46751862B49E6273f9669216A3072b77a3178b65",
      blockCreated: 9428799,
    },
  },
};


export const danChainWagmi: Chain = {
  id: 69,
  name: 'DAN Chain',
  network: 'danmainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'DAN',
    symbol: 'DAN',
  },
  rpcUrls: {
    default: {
      http: ['https://mainnet.danscan.io/'],
    },
    public: {
      http: ['https://mainnet.danscan.io/'],
    },
  },
  blockExplorers: {
    default: {
      name: 'DanScan',
      url: 'https://danscan.io/',
    },
  },
  contracts: {
    multicall3: {
      address: '0x4d76592D83585Cf00792057749B03f97964668E8',
      blockCreated: 97265,
    },
  },
}


export const dannychainWagmi: Chain = {
  id: 5069,
  name: 'Danny',
  network: 'dannymainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'DAN',
    symbol: 'DAN',
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.dannyscan.com'],
    },
    public: {
      http: ['https://rpc.dannyscan.com'],
    },
  },

  blockExplorers: {
    default: { name: 'DannyScan', url: 'https://dannyscan.com' },
  },
  contracts: {
    multicall3: {
      address: '0x762860BbBc43eb1C611076f18668d7ce6b23D4E6',
      blockCreated: 43840,
    },
  }
}

const projectId = '27b9720018bf7f8740936e6a6eb28604'
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal Example',
  url: 'https://web3modal.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const chains = [bsc, bscTestnet]
export const wagmiConfig: any = defaultWagmiConfig({ chains, projectId, metadata })


createWeb3Modal({
  wagmiConfig,
  projectId,
  chains,
  enableAnalytics: true
})